// extracted by mini-css-extract-plugin
export var chip = "_36-9";
export var chipLabel = "_36-a";
export var close = "_36-7";
export var closeIcon = "_36-8";
export var error = "_36-6";
export var infoTooltip = "_36-2";
export var innerContainer = "_36-1";
export var input = "_36-b";
export var medium = "_36-5";
export var outerContainer = "_36-0";
export var small = "_36-4";
export var xSmall = "_36-3";